import '../../../define/i18n';
import '../../../define/ui/container';
import '../../../define/ui/poster';
import '../../../define/ui/buffering-indicator';
import '../../../define/ui/error-dialog';
import '../../../define/ui/dialog-backdrop';
import '../../../define/ui/dialog-popup';
import '../../../define/ui/dialog-title';
import '../../../define/ui/dialog-description';
import '../../../define/ui/dialog-close';
import '../../../define/ui/title';
import '../../../define/ui/controls';
import '../../../define/ui/controls-backdrop';
import '../../../define/ui/controls-content';
import '../../../define/ui/tooltip-group';
import '../../../define/ui/controls-group';
import '../../../define/ui/play-button';
import '../../../define/ui/tooltip';
import '../../../define/ui/tooltip-label';
import '../../../define/ui/tooltip-shortcut';
import '../../../define/ui/mute-button';
import '../../../define/ui/volume-popover';
import '../../../define/ui/volume-slider';
import '../../../define/ui/slider-track';
import '../../../define/ui/slider-fill';
import '../../../define/ui/slider-thumb';
import '../../../define/ui/time-group';
import '../../../define/ui/time';
import '../../../define/ui/time-separator';
import '../../../define/ui/time-slider';
import '../../../define/ui/time-slider-chapters';
import '../../../define/ui/slider-buffer';
import '../../../define/ui/slider-preview';
import '../../../define/ui/slider-thumbnail';
import '../../../define/ui/time-slider-chapter-title';
import '../../../define/ui/slider-value';
import '../../../define/ui/captions-button';
import '../../../define/ui/menu';
import '../../../define/ui/menu-content';
import '../../../define/ui/menu-item';
import '../../../define/ui/menu-separator';
import '../../../define/ui/quality-radio-group';
import '../../../define/ui/menu-radio-item';
import '../../../define/ui/menu-item-indicator';
import '../../../define/ui/audio-track-radio-group';
import '../../../define/ui/playback-rate-radio-group';
import '../../../define/ui/captions-radio-group';
import '../../../define/ui/cast-button';
import '../../../define/ui/airplay-button';
import '../../../define/ui/pip-button';
import '../../../define/ui/fullscreen-button';
import '../../../define/ui/hotkey';
import '../../../define/ui/gesture';
import '../../../define/ui/status-announcer';
import '../../../define/ui/volume-indicator';
import '../../../define/ui/volume-indicator-fill';
import '../../../define/ui/volume-indicator-value';
import '../../../define/ui/status-indicator';
import '../../../define/ui/status-indicator-value';
import '../../../define/ui/seek-indicator';
import '../../../define/ui/seek-indicator-value';
import { registerIcons } from '../../../icons';
import {
  airPlayEnterIcon as airPlayEnterIconMinimal,
  airPlayExitIcon as airPlayExitIconMinimal,
  captionsOffIcon as captionsOffIconMinimal,
  captionsOnIcon as captionsOnIconMinimal,
  castEnterIcon as castEnterIconMinimal,
  castExitIcon as castExitIconMinimal,
  checkIcon as checkIconMinimal,
  chevronIcon as chevronIconMinimal,
  fullscreenEnterIcon as fullscreenEnterIconMinimal,
  fullscreenExitIcon as fullscreenExitIconMinimal,
  gearIcon as gearIconMinimal,
  pauseIcon as pauseIconMinimal,
  pipEnterIcon as pipEnterIconMinimal,
  pipExitIcon as pipExitIconMinimal,
  playIcon as playIconMinimal,
  restartIcon as restartIconMinimal,
  speechIcon as speechIconMinimal,
  speedIcon as speedIconMinimal,
  spinnerIcon as spinnerIconMinimal,
  switchesIcon as switchesIconMinimal,
  volumeHighIcon as volumeHighIconMinimal,
  volumeLowIcon as volumeLowIconMinimal,
  volumeOffIcon as volumeOffIconMinimal,
} from '../../../icons/minimal';

registerIcons('minimal', {
  'airplay-enter': airPlayEnterIconMinimal,
  'airplay-exit': airPlayExitIconMinimal,
  'captions-off': captionsOffIconMinimal,
  'captions-on': captionsOnIconMinimal,
  'cast-enter': castEnterIconMinimal,
  'cast-exit': castExitIconMinimal,
  check: checkIconMinimal,
  chevron: chevronIconMinimal,
  'fullscreen-enter': fullscreenEnterIconMinimal,
  'fullscreen-exit': fullscreenExitIconMinimal,
  gear: gearIconMinimal,
  pause: pauseIconMinimal,
  'pip-enter': pipEnterIconMinimal,
  'pip-exit': pipExitIconMinimal,
  play: playIconMinimal,
  restart: restartIconMinimal,
  speech: speechIconMinimal,
  speed: speedIconMinimal,
  spinner: spinnerIconMinimal,
  switches: switchesIconMinimal,
  'volume-high': volumeHighIconMinimal,
  'volume-low': volumeLowIconMinimal,
  'volume-off': volumeOffIconMinimal,
});
